<template>
    <div class="dashboard cust-drivers cust-drivers--dailyreports">
        <h1>運転日報</h1>
        <input v-model="params.date" class="l-mb4" style="width:200px;" type="date" @change="fetchingListDailyReports()">
        <div class="table-wrap">
            <table class="table--ghost">
                <tr>
                    <th v-for="data in tableSet" :key="data.key" :class="data.class">
                        {{ data.head }}
                    </th>
                </tr>
                <tr v-for="(list, index) in sortingListDailyReports" :key="`list${index}`">
                    <td v-for="data in tableSet" :key="`list${index}${data.key}`" :class="data.class">
                        {{ list[data.key] }}
                    </td>
                </tr>
            </table>
        </div>
        <div class="l-mt10">
            <router-link :to="{ name: 'drivers_work_times' }" class="button--oval--cancel" type="button" tag="button">出社時間確認へ戻る</router-link>
        </div>
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";
    import sorts from "@/mixins/sort";

    const tableDailyReports = [
        {
            "class": "is-wrap",
            "head": "施工業者",
            "key": "contractor",
        },
        {
            "class": "is-wrap",
            "head": "現場名",
            "key": "delivery_destination_name",
        },
        {
            "class": "is-center",
            "head": "車両ID",
            "key": "vehicle_id",
        },
        {
            "class": "is-center",
            "head": "車両サイズ",
            "key": "vehicle_size_name",
        },
        {
            "class": "is-right",
            "head": "納入量（㎥）",
            "key": "delivery_allocations_amount",
        },
        {
            "class": "is-right",
            "head": "工場発時刻", // 元・残水時刻
            "key": "residual_water_time",
        },
        {
            "class": "is-right",
            "head": "現場着時刻",
            "key": "site_arrival_time",
        },
        {
            "class": "is-right",
            "head": "現場発時刻",
            "key": "site_departure_time",
        },
        {
            "class": "is-right",
            "head": "工場着時刻",
            "key": "factory_arrival_time",
        },
    ];

    export default {
        "mixins": [
            common,
            sorts,
        ],
        data() {
            return {
                "listDailyReports": [],
                "dateType": "date",
                "params": {
                    "date": "",
                },
                "tableSet": tableDailyReports,
                "updateCheck": "",
            };
        },
        "computed": {
            sortingListDailyReports() {
                let list = [];
                const listWaterTime = [];
                const listNotWaterTime = [];
                let sortListWaterTime =[];
                let sortListNotWaterTime =[];
                // 工場発時刻（元・残水時刻）の存在を仕分け
                for (let data of this.listDailyReports) {
                    if (data.residual_water_time) {
                        listWaterTime.push(data);
                    } else {
                        listNotWaterTime.push(data);
                    }
                }
                // 工場発時刻（元・残水時刻）で昇順
                sortListWaterTime = this.$_sorting(listWaterTime, "residual_water_time");
                // 現場名で昇順
                sortListNotWaterTime = this.$_sorting(listNotWaterTime, "delivery_destination_name");
                // listにset
                for (let data of sortListWaterTime) {
                    list.push(data);
                }
                for (let data of sortListNotWaterTime) {
                    list.push(data);
                }
                return list;
            },
        },
        created() {
            this.setDate();
            this.fetchingListDailyReports();
        },
        mounted() {
            this.updateCheck = setInterval(() => {
                this.handleUpdate();
            }, 1500);
        },
        beforeDestroy() {
            clearInterval(this.updateCheck);
        },
        "methods": {
            setDate() {
                // 今日の日付をset
                const today = new Date();
                const year = today.getFullYear();
                const month = ("0" + (today.getMonth() + 1)).slice(-2);
                const date = ("0" + today.getDate()).slice(-2);
                this.params.date = `${year}-${month}-${date}`;
            },
            fetchingListDailyReports() {
                // 運転日報データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/daily_reports/0`,
                    this.$_requestConfig("params")
                ).then(response => {
                    this.listDailyReports = response.data;
                }).catch(() => {
                    alert("運転日報の取得に失敗しました。");
                });
            },
            handleUpdate() {
                // 納入先データ（ドライバー用）取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_destinations/driver`,
                    this.$_requestConfig()
                ).then(() => {
                    setTimeout(() => {
                        this.$router.push({ "name": "drivers_delivery_destinations" });
                    }, 1000);
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .is-wrap {
        min-width: 160px;
    }
</style>
